import React from 'react'
import { Box, Typography, Grid, useTheme, Button } from '@mui/material'
import BrandedPageHeader from 'components/Layout/BrandedPageHeader'
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'

const ResidencyTransferPage = () => {
  const theme = useTheme()

  return (
    <Box>
      <BrandedPageHeader>
        <Grid container spacing={0} sx={{ px: 0 }}>
          <Grid item xs={12} md={8} sx={{ pl: 0 }}>
            <Typography variant='h5' sx={{ color: 'white', fontWeight: 'bold', mb: 1, pl: 0 }}>
              Residency Transfer
            </Typography>
            <Typography variant='caption' sx={{
              color: 'rgba(255,255,255,0.7)',
              display: 'block',
              whiteSpace: 'normal',
              wordBreak: 'normal',
              pl: 0
            }}>
              A free platform to help residents find transfer opportunities and programs fill vacancies.
            </Typography>
          </Grid>
        </Grid>
      </BrandedPageHeader>

      <Grid container justifyContent='center' sx={{ mt: 4 }}>
        <Grid item xs={11} md={8} lg={6}>
          <Box
            sx={{
              backgroundColor: 'white',
              padding: { xs: 3, md: 5 },
              borderRadius: '8px',
              border: `1px solid ${theme.palette.grey[300]}`,
              boxShadow: theme.shadows[3],
              textAlign: 'center',
            }}
          >
            <SwapHorizIcon sx={{ fontSize: 48, color: theme.palette.primary.main, mb: 2 }} />
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>
              New Transfer Listings Coming Soon
            </Typography>
            <Typography variant="body1" sx={{ mb: 1, color: theme.palette.text.secondary }}>
              We are now accepting new residency postings.
              If you are a resident looking to transfer programs, find an open position,
              or a program with an available spot, submit your information and we will post it here.
            </Typography>
            <Typography variant="body2" sx={{ mb: 4, color: theme.palette.text.secondary }}>
              Listings are free and visible to the entire MyStethi community.
            </Typography>
            <Button
              variant='contained'
              color='primary'
              size='large'
              startIcon={<SwapHorizIcon />}
              href="https://forms.gle/LeAZ56xtLz9qMx4T7"
              target="_blank"
              sx={{
                py: 1.5,
                px: 4,
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                '&:hover': {
                  boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
                }
              }}
            >
              Transfer Programs
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default ResidencyTransferPage